﻿let facings = [
    { id: 0, title: 'Любая' },
    { id: 1, title: 'Не указана' },
    { id: 2, title: 'Без отделки' },
    { id: 3, title: 'Подготовка' },
    { id: 4, title: 'С отделкой' },
    { id: 5, title: 'С мебелью' }
];

export default facings;
